/*
 * Copyright (c) 2017-2018. Code réalisé par IpsoSenso
 */

import { flatten } from 'flat'
import { ACTION_TYPE, CONTRACT_MODULE, CUSTOMER_SATISFACTION, FORECAST_PROBABILITY, MANUALLY_CLOSED_STATUS, MONTH, VIEW } from '../enums'
import { LEVEL } from '../constants'

export default flatten({
	title: 'RTV NÁSTROJ',
	menu: {
		retour: 'Back to application',
		countries: 'Manage countries',
		renegotiation: 'Renegotiation heatmap', // FIXME
		users: 'Manage users',
		import: 'Import users'
	},
	renegotiation : { // FIXME
		message : 'Adjust each cell based on country sales policy in your local language',
		risk_score: 'Contract risk score',
		price_score: 'Contract price score',
		dialog: {
			title: 'Renegotiation scenario for risk/price score {risk}/{price}',
			tip: 'Tip',
			cancel: 'Cancel',
			update: 'Update'
		}
	},
	searchBar: 'Přejít ke smlouvě, prodejci...',
	login: {
		button: 'Přihlásit se pomocí účtu Microsoft',
		error: 'Váš účet neumožňuje přístup k této aplikaci'
	},
	layout: {
		dashboard: 'Dashboard týmu',
		srOverview: 'Přehled prodejce',
		contractsOverview: 'Přehled kontraktů',
		portfolio: 'Mé portfolio',
		actions: 'Přehled opatření',
		forecasts: 'Forecasts overview', // FIXME
		reporting: {
			label : 'User reporting',
			teams: 'Teams',
			detailed: 'Monthly Reporting'
		},
		notifications: {
			help: {
				title: 'Potřebuji pomoc',
				noContract: 'Žádný kontrakt nevyžaduje pomoc',
				needHelp: '{firstName} {lastName} potřebuje pomoc s {customerName} ({id})'
			},
			overdueContracts: {
				title: 'Kontrakty po termínu',
				noContract: 'Žádný kontrakt po termínu',
				contract: '{customerName} ({id}) je na seznamu priorit již {nbMonths} měsíc/e/ů'
	},
			overdueActions: {
				title: 'Opatření po termínu',
				noAction: 'Žádné opatření po termínu',
				action: '{customerName} ({idContract}): opatření naplánováno na {deadline}'
			}
		},
		logout: 'Odhlášení'
	},
	search: {
		contracts: {
			title: 'Kontrakty',
			noResult: 'Nebyl nalezen žádný výsledek'
		},
		salesRepresentative: {
			title: 'Prodejci',
			noResult: 'Nebyl nalezen žádný výsledek'
		}
	},
	pages: {
		selectCountry: {
			title: 'Vyberte zemi nebo region',
			indicators: {
				withoutActions: 'Kontrakty bez opatření',
				withActions: 'Kontrakty s opatřeními',
				closed: 'Contracts closed' // FIXME
			},
			button: 'Panel týmu',
			seeReporting: 'See reporting',
			backToHomePage: 'Back to home page'

		},
		portfolio: {
			title: 'Mé portfolio',
			breadcrumbs: 'Mé portfolio',
			tabBar: {
				priority: 'Seznam priorit',
				monthly: 'Seznam priorit na tento měsíc',
				all: 'Všechny kontrakty',
				allDetails: 'All Details' // FIXME
			}
		},
		contractsOverview: {
			title: 'Přehled kontraktů',
			breadcrumbs: {
				dashboard: 'Dashboard týmu',
				contractsOverview: 'Přehled kontraktů'
			},
			tabBar: {
				priority: 'Seznam priorit',
				cancelled: 'Poslední stornované kontrakty',
				all: 'Všechny kontrakty'
			},
			filters: {
				title: 'Filtry',
				help: 'Pro zobrazení kontraktů odpovídajících vašemu výběru zvolte jednu nebo více položek v jednom nebo více sloupcích.',
				reset: 'Resetovat filtry',
				apply: 'Použít',
				headers: {
					status: 'Stav kontraktu',
					classification: 'Klasifikace',
					risk: 'Ukazatel rizika',
					value: 'Ukazatel hodnoty',
					flags: 'Alerty',
					endDate: 'Datum vypršení kontraktu',
					riskTypology: 'Typologie rizik',
					customerFeedback: 'Customer feedback' // FIXME
				},
				status: {
					toDo: 'ŽÁDNÁ AKCE',
					inProgress: 'PROBÍHÁ',
					toBeCancelled: 'BUDE ZRUŠEN',
					toBeExtended: 'BUDE PRODLOUŽEN',
					renegociated: 'PŘESMLUVNĚN',
					upgraded: 'HODNOTA ZVÝŠENA',
					downgraded: 'HODNOTA SNÍŽENA'
				},
				classification: {
					high: 'Vysoká hodnota/riziko',
					low: 'Nízká hodnota',
					manually: 'Přidáno manuálně'
				},
				risk: {
					5: '5 - Vysoká',
					4: '4 - Střední',
					3: '3 - Střední',
					2: '2 - Nízká',
					1: '1 - Nízká'
				},
				value: {
					5: '5 - Vysoká',
					4: '4 - Střední',
					3: '3 - Střední',
					2: '2 - Nízká',
					1: '1 - Nízká',
					0: '0 - Záporná'
				},
				flags: {
					help: 'Potřebuji pomoc',
					overdue: 'Po termínu',
					actionsOverdue: 'Opatření po termínu'
				},
				endDate: {
					outdated: 'Passed', // FIXME
					short: '< 3 měsíce',
					medium: '3 - 6 měsíců',
					long: '> 6 měsíců'
				},
				riskTypology: {
					field: 'Servis',
					sales: 'Prodej'
				},
				customerFeedback: { // FIXME
					cancellationLetter: 'Cancellation letter received',
					claimLetter: 'Claim letter received (12 months)'
				}
			},
			sorts: {
				title: 'Sort by', //FIXME
				priority: {
					label: 'Priorita (defaultní)',
					labelShort: 'Priorita'
				},
				risk: {
					label: 'Riziko',
					labelShort: 'Riziko'
				},
				value: {
					label: 'Hodnota',
					labelShort: 'Hodnota'
				},
				endDate: {
					label: 'Datum vypršení kontraktu',
					labelShort: 'Datum ukončení',
				},
				unitsNumber: { // FIXME
					label: 'Units number',
					labelShort: 'Units'
				}
			},
			table: {
				searchBar: {
					classic: 'Hledat podle prodejce, zákazníka nebo čísla kontraktu',
					[CONTRACT_MODULE.FR]: 'Search by SR, supervisor, mechanic, customer, contract id or address' // FIXME
				},
				headers: {
					contract: {
						title: 'Kontrakt',
						cancelled: {
							title: 'Stornován',
							tooltip: 'Kontrakt stornován v CRM'
						},
						needHelp: {
							title: 'Potřebuji pomoc'
						}
					},
					status: {
						title: 'Stav opatření',
						notPriority: {
							title: 'Kontrakt není prioritní',
							tooltip: 'Pro správu opatření k tomuto kontraktu otevřete podrobnosti o kontraktu a klikněte na možnost Přidat do seznamu priorit'
						}
					},
					actionsOpened: 'Probíhají opatření',
					valueIndicator: {
						title: 'Hodnota',
						tooltip: 'Ukazatel hodnoty {indicator}/5 (0 = záporná hodnota)'
					},
					riskIndicator: {
						title: 'Riziko',
						tooltip: 'Ukazatel rizika {indicator}/5'
					},
					riskTypology: {
						title: 'Typologie rizik',
						flag: {
							sales: 'Prodejní ukazatele',
							field: 'Servisní ukazatele',
						}
					},
					endDate: {
						title:  'Datum vypršení kontraktu',
						tooltip: {
							desktop: 'Prioritní kontrakt otevřen déle než 3 měsíce',
							mobile: 'Kontrakt je stále otevřen',
							contractEndTypology: 'Contract end type :', // FIXME
							requestedCancellationDate: 'Cancellation date requested :'
						}
					},
					unitsNumber: { // FIXME
						title: 'Jednotky',
						tooltip: 'Selling price :'
					},
					advancedNoticePeriodDate: 'Advanced Notice Period Deadline',
				},
				noResult: 'Nenalezeny žádné kontrakty',
				loading: 'Loading contracts',
				show: 'Zobrazit kontrakt'
			},
			otherContract: {
				title: 'Ostatní kontrakty',
				contracts: 'Kontrakty',
				salesRep: 'Prodejce',
				portfolio: 'My Portfolio' // FIXME
			},
			otherSR: {
				title: 'Jiný prodejce',
				noResult: 'Nenalezeni žádní jiní prodejci',
				headers: {
					sales: 'Prodejce',
					contracts: 'Kontrakty'
				}
			}
		},
		salePortfolioManager: {
			breadcrumbs: {
				dashboardRegional: 'Region dashboard', // FIXME
				dashboard: 'Dashboard týmu',
				srOverview: 'Přehled prodejce',
				srPortfolio: '{firstName} {lastName}\'s portfolio',
				portfolio: 'Portfolio'
			},
			title: {
				srPortfolio: '{firstName} {lastName}\'s portfolio',
				portfolio: 'Portfolio'
			}
		},
		contract: {
			comparison: {
				hide: ' Skrýt',
				show: ' Zobrazit',
				text: 'cenové srovnání s podobnými kontrakty',
				tooltip: 'Uvádí pozici kontraktu ve srovnání s ostatními kontrakty s podobnými charakteristikami (počet jednotek, typ kontraktu a zákazníka…) v portfoliu v České republice.',
				chart: {
					price: 'Pozice kontraktu z hlediska ceny',
					value: 'Pozice kontraktu z hlediska hodnoty'
				},
				portfolioValue: 'Growth of portfolio (current year) : ' // FIXME
			},
			risk: {
				close: {
					title: 'Uzavřít riziko manuálně',
					outcome: {
						title: 'Výsledek',
						to_be_autorenewed: {
							label: 'Bude prodloužen',
							detail: '(Kontrakt bude automaticky prodloužen)'
						},
						to_be_cancelled: {
							label: 'Bude zrušen',
							detail: '(Kontrakt nelze zachránit; bude zrušen)'
						},
						renegotiated: {
							label: 'Kontrakt přesmluvněn',
							detail: '(Přesmluvněn; stejná hodnota kontraktu)'
						},
						upgraded: {
							label: 'Přesmluvněn na vyšší hodnotu',
							detail: '(Přesmluvněn; hodnota kontraktu zvýšena)'
						},
						downgraded: {
							label: 'Přesmluvněn na nižší hodnotu',
							detail: '(Přesmluvněn; hodnota kontraktu snížena)'
						}
					},
					comment: 'Poznámka',
					cancel: 'Storno',
					button : 'Uzavřít riziko manuálně',
					errors: {
						required: 'Povinné',
						mandatory: 'Povinné informace'
					}
				}
			},
			charts: {
				range: 'Rozsah {rangeMin} {currency} - {rangeMax} {currency}',
				median: 'Medián {median} {currency}'
			},
			flags: {
				description :{
					ContractAge: 'Staří kontraktu#Kontrakt patří mezi 20 % nejstarších kontraktů',
					ContractDuration: 'Kontrakt bez automatického prodloužení#Kontrakt s datem vypršení za < 6 měsíců',
					Public: 'Veřejná zakázka#Zákazníkem je veřejný subjekt',
					CustomerType: 'Typ zákazníka#Zákazník chce vyjednat nové podmínky',
					NationalAccount: 'Celonárodní zákazník#Jedná se o celonárodního zákazníka.',
					Recovery: 'Znovu získaný Otis kontrakt #Kontrakt získaný od konkurence',
					SellingPrice: 'Vysoká cena za jednotku#Kontrakt patří mezi top 20 % z hlediska ceny za jednotku',
					ContractValue: 'Vysoká hodnota za jednotku#Kontrakt patří mezi top 20 % z hlediska hodnoty za jednotku',
					Units: 'Počet jednotek: kontrakt patří mezi top 20 % z hlediska počtu jednotek',
					Rebel: 'Vysoký poměr rebel jednotek#Kontrakt za posledních 12 měsíců patří mezi top 20 % z hlediska počtu rebel jednotek',
					Callbacks: 'Vysoký počet callbacků na jednotku: kontrakt za posledních 12 měsíců patří mezi top 20 % z hlediska počtu callbacků na jednotku',
					ResponseTime: 'Dlouhá průměrná doba reakce#Kontrakt za posledních 12 měsíců patří mezi top 20 % z hlediska průměrné doby reakce na jednotku',
					Availability: 'Nižší provozuschopnost na jednotku# Kontrakt za posledních 12 měsíců patří mezi top 20 % z hlediska snížené provozuschopnosti na jednotku',
					MissedMaintenance: 'Neprovedená údržba# Kontrakt za posledních 12 měsíců patří mezi top 20 % z hlediska neprovedené údržby',
					Trapped: 'Žádosti o vyproštění cestujících# Kontrakt za posledních 12 měsíců patří mezi top 20 % z hlediska počtu žádostí o vyproštění cestujících'
				},
				close: 'Zavřít'
			},
			breadcrumbs: {
				dashboardRegional: 'Region dashboard', // FIXME
				dashboard: 'Dashboard týmu',
				srOverview: 'Přehled prodejce',
				srPortfolio: '{firstName} {lastName}\'s portfolio',
				contract: '{name} ({contractId})',
				myPortfolio: 'Mé portfolio'
			},
			actions: {
				close: 'Uzavřít riziko',
				add: 'Přidat do seznamu priorit',
				help: {
					title: 'Pomoc manažera',
					tooltip: 'Vyžádat si pomoc manažera oblasti'
				}
			},
			information: {
				title: 'Informace a řízení rizik',
				status: {
					TODO: 'ŽÁDNÁ AKCE',
					IN_PROGRESS: 'PROBÍHÁ',
					TO_BE_CANCELLED: 'BUDE ZRUŠEN',
					TO_BE_AUTO_RENEWED: 'BUDE PRODLOUŽEN',
					RENEGOTIATED: 'PŘESMLUVNĚN',
					UPGRADED: 'HODNOTA ZVÝŠENA',
					DOWNGRADED: 'HODNOTA SNÍŽENA',
					CLOSED_AUTOMATICALLY: 'TO BE EXTENDED'
				},
				headers: {
					contractValue: {
						title: 'Hodnota kontraktu',
						tooltip: 'Roční fakturovaná částka za O + průměrné prodeje T < 5 tisíc € za poslední 3 roky'
					},
					// TODO
					customerIdCrm: "Customer number",
					value: 'Hodnota',
					riskTypology: {
						title: 'Typologie rizik',
						flags: {
							sales: {
								title: 'Prodejní ukazatele',
								name: 'Prodeje'
							},
							field: {
								title: 'Servisní ukazatele',
								name: 'Servis'
							}
						}
					},
					units: 'Jednotky',
					price: {
						title: 'Cena za údržbu dle kontraktu',
						tooltip: 'Roční fakturovaná částka za O'
					},
					risk: 'Riziko',
					callbacks: 'Callbacky',
					endDate: 'Datum vypršení kontraktu',
					invoicesValue: 'Hodnota neuhrazených faktur',
					address: 'Site address', // FIXME
					renegotiationTip: { // FIXME
						header: 'Reneg. principle',
						dialogTitle : 'Renegotiation principle for this contract',
						noTip: 'This contract has no billing and is certainly cancelled',
						outlier: 'This contract is very specific and needs an approval from management in case of renegotiation'
					}
				},
				closed: {
					button: 'Znovu otevřít riziko',
					text: 'Riziko dne {date} uzavřel/a {firstName} {lastName}',
					textAuto: 'Riziko automaticky uzavřeno dne {date}'
				},
				comment: 'Poznámka',
				dialog: {
					error: {
						title: 'Riziko nelze uzavřít',
						text: 'Před uzavřením rizika je nutné uzavřít všechna opatření.',
						close: 'Zavřít'
					},
					notAvailable: {
						title: 'Opatření není k dispozici',
						text: 'Riziko může znovu otevřít pouze váš manažer',
						cancel: 'Zavřít'
					},
					reOpen: {
						title: 'Potvrzení opětovného otevření rizika',
						text: 'Chcete riziko znovu otevřít? (předchozí výsledek a poznámky budou smazány)',
						confirm: 'Znovu otevřít riziko'
					},
					addPriority: {
						title: 'Přidat do seznamu priorit',
						text: 'Chcete tento kontrakt přidat do seznamu priorit?',
						confirm: 'Přidat kontrakt',
						cancel: 'Zavřít'
					}
				},
				tabs: { // FIXME
					tab: {
						details: 'Contract details',
						actions: 'Actions',
						zeroAction: 'Create your first action'
					},
					detailsTab: {
						moduleFrance: {
							advancedNoticePeriodDate: 'Advanced Notice Period Deadline',
							contractCategory: 'Contract type',
							requestedCancellationDate: 'Cancellation Date Requested',
							claimLettersNb: 'Number of claim letters received',
							supervisorName: 'Supervisor name',
							mechanicName: 'Mechanic name',
							customerSatisfactionLvl: {
								title: 'Customer satisfaction',
								[CUSTOMER_SATISFACTION.UNSATISFIED]: 'Unsatisfied',
								[CUSTOMER_SATISFACTION.SATISFIED]: 'Satisfied'
							},
							contractEndTypology: 'Type of contract end',
						},
						comments: {
							empty: 'No comment was made',
							lastModified: 'Last modified on {date} by {firstName} {lastName}',
							updateComment: 'Update comment',
							managersTitle: 'General comment by managers',
							srTitle: 'General comment by SR',
							dialog: {
								comment: 'Comment',
								cancel: 'Cancel',
								update: 'Update'
							}
						}
					}
				}
			},
			forecast: { // FIXME
				title: 'Forecast',
				probability: {
					label: 'Probability',
					high: 'High range',
					low: 'Low range'
				},
				cancellationMonth: {
					label: 'Cancellation month',
				},
				save: 'Save forecast',
				errors: {
					required: 'Required',
					outdated: 'Outdated forecast'
				},
				snackbar: {
					success: 'Forecast added',
					error: 'Error in adding'
				}
			}
		},
		dashboard: {
			title: 'Dashoard týmu - {level}',
			branch: {
				table: {
					titleNational: 'Country open contracts', // FIXME
					titleRegion: 'Region open contracts',
					headers: {
						branchName: 'Oblast',
						todo: 'Otevřené kontrakty bez opatření',
						inProgressCount: 'Otevřené kontrakty s opatřeními',
						closedCount: 'Uzavřené kontrakty'
					},
					noResult: 'Nenalezeny žádné oblasti'
				}
			},
			region: {
				table: {
					title: 'Regions open contracts',
					headers: {
						regionName: 'Region',
						todo: 'Open contracts without actions',
						inProgressCount: 'Open contracts with actions',
						closedCount: 'Closed contracts'
					},
					noResult: 'No regions found'
				} // FIXME
			},
			highRisk: {
				table: {
					title: 'Kontrakty s vysokou hodnotou/vysokým rizikem',
					headers: {
						contract: 'Kontrakt',
						actionsOpened: 'Probíhají opatření',
						valueIndicator: 'Hodnota',
						riskIndicator: 'Riziko'
					},
					tooltip: {
						value: 'Ukazatel hodnoty {indicator}/5 (0 = záporná hodnota)',
						risk: 'Ukazatel rizika {indicator}/5'
					},
					noResult: 'Nenalezeny žádné kontrakty'
				},
				button : 'Zobrazit všechny kontrakty (měsíční porada)'
			},
			priorityOpenContracts: {
				title: 'Prioritní otevřené kontrakty',
				indicators: {
					srNeedHelp: 'Prodejce potřebuje pomoc',
					contractionWithActionsOverdue: 'Kontrakty s opatřeními po termínu',
					contractsOverdue: 'Kontrakty po termínu'
				},
				button: 'Zobrazit všechny kontrakty',
				contracts: 'Kontrakty'
			},
			salesRep: {
				title: {
					national: 'Celonárodní',
					openContracts: 'otevřené kontrakty'
				},
				table: {
					headers: {
						lastName: 'Prodejce',
						todo: 'Otevřené kontrakty bez opatření',
						inProgress: 'Otevřené kontrakty s opatřeními',
						closed: 'Uzavřené kontrakty'
					},
					noResult: 'Nenalezeni žádní prodejci'
				},
				button: 'Zobrazit všechny prodejce'
			},
			topPriorityContracts: {
				title: 'Rozdělení kontraktů s nejvyšší prioritou',
				tooltip: '{nb} kontraktů',
				type: {
					noAction: 'Žádné opatření',
					inProgress: 'Probíhá',
					manuallyClosed: 'Manuálně uzavřen'
				}
			},
			manuallyClosedContracts: {
				title: 'Uzavřené prioritní kontrakty',
				tooltip: 'Stav manuálně uzavřených kontraktů (stav storno v CRM není zohledněn)',
				headers: {
					all: 'Všechny kontrakty',
					high: 'Vysoká hodnota/riziko',
					low: 'Nízká hodnota'
				},
				rows: {
					[MANUALLY_CLOSED_STATUS.TO_BE_CANCELLED]: {
						title: `Bude zrušen`,
						tooltip: 'Kontrakt nelze zachránit; bude zrušen'
					},
					[MANUALLY_CLOSED_STATUS.TO_BE_AUTO_RENEWED]: {
						title: `Bude prodloužen`,
						tooltip: 'Kontrakt bude automaticky prodloužen'
					},
					[MANUALLY_CLOSED_STATUS.RENEGOTIATED]: {
						title: 'Kontrakt přesmluvněn',
						tooltip: 'Přesmluvněn; stejná hodnota kontraktu'
					},
					[MANUALLY_CLOSED_STATUS.UPGRADED]: {
						title: `Přesmluvněn na vyšší hodnotu`,
						tooltip: 'Kontrakty přesmluvněné na vyšší hodnotu'
					},
					[MANUALLY_CLOSED_STATUS.DOWNGRADED]: {
						title: `Přesmluvněn na nižší hodnotu`,
						tooltip: 'Kontrakty přesmluvněné na nižší hodnotu'
					}
				}
			}
		},
		srPortfolio: {
			openActions: {
				title: '{count} Probíhající opatření u mých prioritních kontraktů',
				plannedActions: {
					title: 'Plánovaná',
					tooltip: '{count} plánovaná opatření'
				},
				overdueActions: {
					title: 'Po termínu',
					tooltip: '{count} Opatření po termínu'
				},
				button: 'Zobrazit všechna opatření'
			},
			priorityContracts: {
				title: 'Mé prioritní otevřené kontrakty',
				noActionPlanned: 'Kontrakty bez naplánovaných opatření',
				highValue: 'Vysoká hodnota/riziko',
				lowValue: 'Nízká hodnota',
				manually: 'Přidáno manuálně',
				nbContracts: '{nb} kontraktů'
			},
			followUp: { // FIXME
				title: 'Contracts follow up',
				openActions: {
					title: '{count} actions',
					planned: {
						title: 'Planned',
						tooltip: '{count} planned actions'
					},
					overdue: {
						title: 'Overdue',
						tooltip: '{count} overdue actions'
					}
				},
				forecasts: {
					title: 'Forecast',
					high: {
						title: 'HP',
						tooltip: '{count} HP'
					},
					low: {
						title: 'LP',
						tooltip: '{count} LP'
					}
				},
				button: 'Show all'
			},
		},
		srOverview: {
			title: {
				mobile: 'Přehled prodejce',
				desktop: 'Přehled prodejce (prioritní kontrakty)'
			},
			breadcrumbs: {
				dashboard: 'Dashoard týmu',
				srOverview: 'Přehled prodejce'
			},
			row: {
				title: '{openContracts} otevřené kontrakty, {totalContracts} celkem ({openContractsPercentage}%)',
				subtitle: '{nbActions} bez opatření'
			},
			table: {
				headers: {
					lastName: 'Prodeje',
					openContractsCount: {
						title: 'Otevřené kontrakty',
						text: '{nbContracts} bez opatření'
					},
					openActionsCount: {
						title: 'Zbývající opatření',
						text: '{nbActions} opatření po termínu'
					},
					overdueCount: 'Kontrakty po termínu',
					toBeCancelled: 'Bude zrušen',
					toBeAutoRenewed: 'Bude prodloužen',
					renegotiated: 'Přesmluvněn',
					upgraded: 'Hodnota zvýšena',
					downgraded: 'Hodnota snížena',
					openActions: {
						title: 'Probíhající opatření',
						text: '{nbActions} po termínu'
					},
					overdueContracts: 'Kontrakty po termínu'
				},
				noResult: 'Nenalezen žádný prodejce'
			}
		},
		reporting : { // FIXME
			month: {
				[MONTH.JANUARY]: 'January',
				[MONTH.FEBRUARY]: 'February',
				[MONTH.MARCH]: 'March',
				[MONTH.APRIL]: 'April',
				[MONTH.MAY]: 'May',
				[MONTH.JUNE]: 'June',
				[MONTH.JULY]: 'July',
				[MONTH.AUGUST]: 'August',
				[MONTH.SEPTEMBER]: 'September',
				[MONTH.OCTOBER]: 'October',
				[MONTH.NOVEMBER]: 'November',
				[MONTH.DECEMBER]: 'December'
			},
			filters: {
				level: {
					all: {
						[LEVEL.REGION]: 'All regions',
						[LEVEL.BRANCH]: 'All branches',
						[LEVEL.SALES_REP]: 'All sales reps',
						default: 'Perimeter'
					},
					[LEVEL.REGION]: 'Regions',
					[LEVEL.BRANCH]: 'Branches',
					[LEVEL.SALES_REP]: 'Sales Reps',
					[LEVEL.USER]: 'Sales Rep',
					default: 'Perimeter'
				},
				year: 'Year',
				view: {
					label: 'Display model',
					[VIEW.MONTHLY]: {
						performance: 'Monthly view',
						adoption: 'Monthly view'
					},
					[VIEW.YEAR_TO_DATE]: {
						performance: 'Year To Date',
						adoption: 'Monthly average'
					}
				}
			},
			tabBar: {
				adoption: 'Adoption',
				activity: 'Activity',
				performance: 'Performance'
			},
			teams: {
				title: 'Teams',
				graph: {
					performance: {
						title: '% of contracts saved VS contracts lost',
						legend : 'YTD %'
					},
					activity: {
						title: '% of contracts with overdue actions',
						legend : 'YTD %'
					},
					adoption: {
						title: 'Adoption overview',
						legend : '% of contracts with actions + contracts closed vs total contracts at risk'
					}
				}
			},
			detailed: {
				title: 'Monthly Reporting',
				perimeter: 'Perimeter',
				graph: {
					title: 'Contracts saved',
					value: 'Value',
					units: 'Units'
				}
			},
			noResult: 'No data found',
			performance: {
				table: {
					tooltip : {
						savedContracts : 'Contracts closed as Renegotiated and Extended',
						lostContracts: 'Contracts closed as cancelled',
						savedContractsRate: 'Contracts saved vs contracts lost',
						renegociatedContractsRate: 'Contracts renegotiated vs total of contracts closed',
					},
					month: 'Month',
					savedContracts : '<baliseToolTip>Contracts saved {br} (Units/value)</baliseToolTip>',
					lostContracts: '<baliseToolTip>Contracts lost {br} (Units/value)</baliseToolTip>',
					savedContractsRate: '<baliseToolTip>Contracts saved rate {br} (Units/value)</baliseToolTip>',
					renegociatedContracts: 'Contracts renegotiated {br} (Units/value)',
					renegociatedContractsRate: '<baliseToolTip>Contracts renegotiated rate {br} (Units/value)</baliseToolTip>',
					total: 'Total'
				},
				tooltip : {
					good: '% of contracts saved > 95%',
					bad: '% of contracts saved < 80%'
				}
			},
			activity: {
				table: {
					day: 'Day',
					noActionsContracts : 'Contracts without actions {br} (Units/value)',
					contractsWithActions: 'Contracts with actions {br} (Units/value)',
					contractsWithActionsRate: 'Contracts % with actions',
					contractsWithOverdueActionsRate: 'Contracts % with overdue actions',
					contractsWithHelpRequested: 'Contracts with manager help requested',
					total: 'Total'
				},
				tooltip : 'At least 50% of open contracts should have an action'
			},
			adoption: {
				table: {
					month: 'Month',
					nbConnexion : 'Connection to RTV (# of days)',
					nbChangementsActions: '# of actions updated or modified',
					nbActionsOuvertes: '# of action opened in the month',
					nbChangementsDate: '# of actions deadlines changed',
					nbAjoutContrats: '# of contracts added manually',
					total: 'Total'
				},
				tooltip : 'High number of actions deadlines changed'
			},
			level : {
				[LEVEL.COUNTRY]: 'Countries',
				[LEVEL.REGION]: 'Regions',
				[LEVEL.BRANCH]: 'Branches',
				[LEVEL.SALES_REP]: 'Sales Representatives',
				[LEVEL.USER]: 'Sales Representative',
			}
		},
	},
	valueIcon: {
		high: 'Prioritní kontrakt s vysokou hodnotou/vysokým rizikem od {month}/{year}',
		low: 'Prioritní kontrakt s nízkou hodnotou od {month}/{year}',
		manually: 'Manuálně přidán do seznamu priorit'
	},
	router: {
		error: {
			title: 'Spojení s API ztraceno',
			content: 'Obnovte prosím stránku nebo se znovu přihlaste.'
		}
	},
	profiles: {
		ZONE_MANAGER: 'EMEA',
		NATIONAL: 'Národní',
		BRANCH_MANAGER: 'Manažer oblasti',
		SALES_REPRESENTATIVE: 'Prodejce',
		BRANCH_MANAGER_ASSISTANT: 'Branch manager assistant', //FIXME
		REGIONAL_MANAGER: 'Regional manager' //FIXME
	},
	actionButton: {
		cancel: 'Storno'
	},
	language: {
		fr: 'Francouzština',
		en: 'Angličtina',
		cze: 'Czech', //FIXME
		de: 'German', //FIXME,
		sp: 'Spanish', //FIXME
		pt: 'Portugese',
		ita: 'Italian'
	},
	action: {
		filters: {
			all: 'Zobrazit všechna opatření',
			open: 'Zobrazit probíhající opatření',
			closed: 'Zobrazit uzavřená opatření'
		},
		form: {
			select: 'Vybrat opatření...',
			comparison: 'Tento kontrakt je příliš specifický, a proto neumožňuje cenové srovnání',
			type: 'Typ opatření',
			deadline: 'Termín',
			description: 'Popis'
		},
		page: {
			title: '{firstName} {lastName}\'s přehled opatření',
			defaultTitle: 'Přehled opatření',
			breadcrumbs: {
				dashboard: 'Dashboard týmu',
				srOverview: 'Přehled prodejce',
				repPortfolio: '{firstName} {lastName}\'s portfolio',
				actionsOverview: 'Přehled opatření',
				myPortfolio: 'Mé portfolio'
			},
			list: {
				noResult: 'Nenalezena žádná opatření',
				headers: {
					action: 'Opatření',
					status: 'Stav',
					description: 'Popis',
					deadline: 'Termín'
				},
				tooltip: 'Opatření po termínu',
				button: 'Zobrazit kontrakt'
			},
			table: {
				searchBar: 'Hledat podle zákazníka, čísla kontraktu nebo popisu',
				filters: {
					type: 'Typ opatření...'
				}
			}
		},
		contract: {
			searchBar: 'Vyhledat popis opatření',
			addButton: 'Přidat nové opatření',
			noResult: 'Nenalezena žádná opatření',
			openBy: 'Otevřel/a {firstName} {lastName}',
			closedOn: 'Dne {date} uzavřel/a {firstName} {lastName}',
			lastModified: 'Naposledy upravil/a {date} {firstName} {lastName}',
			button: {
				update: 'Aktualizovat opatření',
				close: 'Uzavřít opatření'
			},
			confirmation: {
				title: 'Potvrzení uzavření opatření',
				content: 'Chcete uzavřít opatření?',
				buttonLabel: 'Uzavřít opatření',
			},
			new: {
				title: 'OPATŘENÍ',
				buttonLabel: 'Vytvořit opatření',
				cancel: 'Zavřít'
			},
			update: {
				title: 'OPATŘENÍ',
				buttonLabel: 'Uložit'
			},
			deadline: 'Termín',
		},
		status: {
			all: 'Všechna opatření',
			open: {
				label: 'Probíhající opatření',
				chipLabel: 'Otevřít',
			},
			closed: {
				label: 'Uzavřená opatření',
				chipLabel: 'Uzavřená',
			}
		},
		type: {
			all: {
				label: 'Všechny typy',
			},
			[ACTION_TYPE.FIRST_CALL]: {
				label: 'První volání',
				defaultDescription: 'Zavolejte zákazníkovi kvůli zjištění jeho spokojenosti a stavu kontraktu',
			},
			[ACTION_TYPE.CUSTOMER_MEETING]: {
				label: 'Jednání se zákazníkem',
				defaultDescription: 'Navštivte zákazníka kvůli posílení vzájemného vztahu a zjištění stavu kontraktu',
			},
			[ACTION_TYPE.REPORT_TO_CUSTOMER]: {
				label: 'Zákazníkovi poskytněte informace',
				defaultDescription: 'Zákazníkovi poskytněte informace s cílem zvýšit jeho spokojenost',
			},
			[ACTION_TYPE.PROACTIVE_PROPOSAL]: {
				label: 'Proaktivní návrh',
				defaultDescription: 'Před vypršením kontraktu předložte návrh na jeho prodloužení',
			},
			[ACTION_TYPE.RENEGOTIATION]: {
				label: 'Vyjednání nových podmínek',
				defaultDescription: 'Na žádost zákazníka předložte návrh nového kontraktu',
			},
			[ACTION_TYPE.DOWNSELL]: {
				label: 'Snížení hodnoty',
				defaultDescription: 'Navrhněte snížení hodnoty kontraktu, aby byl nadále konkurenceschopný ',
			},
			[ACTION_TYPE.UPSELL]: {
				label: 'Zvýšení hodnoty',
				defaultDescription: 'Navrhněte upgrade kontraktu a s ním i zvýšení ceny a hodnoty',
			},
			[ACTION_TYPE.SEND_MECHANIC_TO_JOBSITE]: {
				label: 'Na místo instalace vyšlete technika',
				defaultDescription: 'Odstraňte technický problém na jednotce',
			},
			[ACTION_TYPE.SEND_SUPERVISOR_TO_JOBSITE]: {
				label: 'Na místo instalace vyšlete mistra',
				defaultDescription: 'Proveďte kontrolu jednotky, abyste předešli riziku callbacků',
			},
			[ACTION_TYPE.CONTACT_SUPERVISOR_MECHANIC]: {
				label: 'Kontaktujte mistra/technika',
				defaultDescription: 'Obeznamte se s technickým stavem jednotky',
			},
			[ACTION_TYPE.OTHER]: {
				label: 'Jiné',
			},
			[ACTION_TYPE.CUSTOMER_CLAIM]: {
				label: 'Vyřizování stížnosti'
			},
			[ACTION_TYPE.CANCELLATION_REQUEST]: {
				label: 'SPRAVA ZADOSTI O UKONCENI'
			}
		}
	},
	user: {
		new: {
			title: 'Vytvoření uživatele',
			buttonLabel: 'Vytvořit'
		},
		update: {
			title: 'Úprava uživatele',
			buttonLabel: 'Aktualizovat'
		},
		form: {
			errors: {
				required: 'Povinné',
				invalidFormat: 'Neplatný formát',
				max255char: 'Povoleno je maximálně 255 znaků',
				emailExists: 'This email already exists.', //FIXME
				emailInactive: 'This email is currently inactive.'
			},
			fields: {
				lastName: 'Příjmení *',
				firstName: 'Křestní jméno *',
				email: 'Email *',
				profile: 'Profil',
				country: 'Země',
				branches: 'Oblast(i)',
				region: 'Region' //FIXME
			}
		},
		table: {
			headers: {
				lastName: 'Příjmení',
				firstName: 'Křestní jméno',
				email: 'Email',
				branch: 'Oblast(i)',
				profile: 'Profil',
				country: 'Země',
				region: 'Region' //FIXME
			},
			actions: {
				reactivate: 'Reaktivovat',
				modify: 'Upravit',
				deactivate: 'Deaktivovat'
			},
			filters: {
				searchBar: 'Filtrovat podle uživatelského jména, emailu nebo oblasti',
				select: {
					placeholder: 'Profil',
					all: 'Všechny profily',
					national: 'Národní',
					branchManager: 'Manažer oblasti',
					branchManagerAssistant: 'Branch Manager Assistant', //FIXME
					salesRepresentative: 'Prodejce',
					regionalManager: 'Regional Manager' //FIXME
				},
				switch: 'Zobrazit deaktivované uživatele',
				reset: 'RESETOVAT'
			}
		},
		menu: {
			myAccount: 'Můj účet',
			quit: 'Konec'
		}
	},
	errors: {
		mandatory: 'Povinné pole',
		onlyFutureDate: 'Pouze budoucí datum'
	},
	countries: {
		table: {
			headers: { // FIXME
				name: 'Name',
				lowValueThreshold: 'Low value threshold',
				highRiskValueThreshold: 'High risk value threshold',
				lowValueAmount: 'Low value contract amount',
				highRiskValueAmount: 'High risk value contract amount',
				refresh: 'Update on import',
				forecastModule: 'Forecast module'
			},
			actions: {
				modify: 'Modifier'
			},
			values: {
				false: 'No',
				true: 'Yes'
			}
		},
		dialog: {
			title: 'Country modification',
			labels: {
				name: 'Name *',
				lowValueThreshold: 'Low value threshold *',
				highRiskValueThreshold: 'High risk value threshold *',
				lowValueAmount: 'Low value contract amount *',
				highRiskValueAmount: 'High risk value contract amount *',
				refresh: 'Update on import *',
				forecastModule: 'Forecast module *',
				usdConversionRate: 'Conversion rate to $USD'
			},
			values: {
				false: 'No',
				true: 'Yes'
			},
			actions: {
				cancel: 'Cancel',
				update: 'Update'
			},
			errors: {
				required: 'Required',
				negative: 'Value must be higher than 0',
				maximum: 'Value must be lower than 1000'
			}
		}
	},
	forecasts: { // FIXME
		page: {
			title: '{firstName} {lastName}\'s forecasts overview',
			defaultTitle: 'Forecasts overview',
			breadcrumbs: {
				dashboard: 'Team dashboard',
				srOverview: 'SR overview',
				repPortfolio: '{firstName} {lastName}\'s Portfolio',
				forecastsOverview: 'Forecasts overview',
				myPortfolio: 'My Portfolio'
			},
			list: {
				noResult: 'No forecast found',
				searchBar: 'Search by customer or contract id',
				headers: {
					contract: 'Contract ({contractNumber})',
					status: 'Status',
					units: 'Jednotky ({unitsNumber})',
					unitsEmpty: 'Jednotky',
					probability: 'Forecast',
					cancellationMonth: 'Cancellation Month'
				},
				information: {
					status: {
						TODO: 'NO ACTION',
						IN_PROGRESS: 'IN PROGRESS',
						TO_BE_CANCELLED: 'TO BE CANCELLED',
						TO_BE_AUTO_RENEWED: 'TO BE EXTENDED',
						RENEGOTIATED: 'RENEGOTIATED',
						UPGRADED: 'UPGRADED',
						DOWNGRADED: 'DOWNGRADED'
					},
					cancellationMonth: {
						old: 'Outdated forecast'
					}
				}
			},
			searchBar: 'Search by customer or contract id'
		},
		probability: {
			all: {
				label: 'LP + HP',
			},
			[FORECAST_PROBABILITY.LOW]: {
				label: 'LP',
				defaultDescription: 'Low Probability',
			},
			[FORECAST_PROBABILITY.HIGH]: {
				label: 'HP',
				defaultDescription: 'High Probability',
			},
		},
		cancellationMonth: {
			all: {
				label: 'All Months'
			},
			outdated: {
				label: 'Outdated'
			}
		}
	},
	import: { // FIXME
		form: {
			country: {
				label: 'Country',
				errors: {
					required: 'Required',
				}
			},
			file: {
				label: 'File',
				empty: 'No file',
				button: 'Select a file',
				errors: {
					required: 'Required',
					wrongFormat: 'Wrong file format'
				}
			},
			submit: 'Import'
		},
		results: {
			header: {
				added: 'Number of added users: {count}',
				errors: 'Number of errors: {count}'
			},
			success: 'Added user: {email}',
			errors: {
				regionMissing: 'Region ID missing',
				branchNotInRegion: 'Branch not found in given region',
				branchNotFound: 'Branch not found',
				regionNotFound: 'Region not found',
				branchMissing: 'Branch ID missing',
				profile: 'Profile not found',
				noRegionInCountry: 'No region in this country',
				emailFormat: 'Wrong email format',
				emailMissing: 'Line {line}: Email not found',
				emailMissingExtended: 'Line {line} - {name}: Email not found',
				wrongProfile: 'No match with database profile'
			}
		}
	},
	crm: {
		btn: 'Run contract export to CRM Italy',
		success: 'Success of exporting contract to CRM Italy',
		error: 'Error while exporting contract to CRM Italy',
		loading: 'Exporting contract to CRM Italy...',
		date: {
			title: 'Date',
			helperText: 'Required format : dd-mm-yyyy',
			invalid: 'Invalid format'
		}
	}
})
